/**
 * Home reviews — video cards + optional Embla carousel (>3 reviews).
 * Carousel motion matches Crowd Pleasers (home-carousel.js).
 */
(function () {
  var PLAY_ICON =
    '<svg viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><path d="M4 2.25v7.5l6-3.75L4 2.25Z"/></svg>';
  var PAUSE_ICON =
    '<svg viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><rect x="2.75" y="2.25" width="2.25" height="7.5" rx="0.25"/><rect x="7" y="2.25" width="2.25" height="7.5" rx="0.25"/></svg>';
  var MUTE_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4V5Z"/><path d="m23 9-6 6"/><path d="m17 9 6 6"/></svg>';
  var UNMUTE_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4V5Z"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>';

  function reviewerName(card) {
    var el = card.querySelector('.home-review-name');
    return (el && el.textContent && el.textContent.trim()) || 'reviewer';
  }

  function syncMuteUI(card) {
    var video = card.querySelector('[data-review-video]');
    var muteBtn = card.querySelector('[data-review-mute]');
    if (!video || !muteBtn) return;
    var muted = video.muted;
    muteBtn.setAttribute('data-state', muted ? 'muted' : 'unmuted');
    muteBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
    muteBtn.innerHTML = muted ? MUTE_ICON : UNMUTE_ICON;
  }

  function syncPlayUI(card, playing) {
    var control = card.querySelector('[data-review-control]');
    if (!control) return;
    var name = reviewerName(card);
    card.classList.toggle('is-playing', playing);
    if (playing) card.classList.add('has-media-started');
    control.setAttribute('data-state', playing ? 'playing' : 'paused');
    control.setAttribute('aria-label', (playing ? 'Pause' : 'Play') + ' video review from ' + name);
    control.innerHTML = playing ? PAUSE_ICON : PLAY_ICON;
  }

  function pauseCard(card) {
    var video = card.querySelector('[data-review-video]');
    if (!video) return;
    video.pause();
    syncPlayUI(card, false);
  }

  function playCard(card, cards) {
    var video = card.querySelector('[data-review-video]');
    if (!video) return;

    cards.forEach(function (other) {
      if (other !== card) pauseCard(other);
    });

    video.muted = video.dataset.userUnmuted !== 'true';
    syncMuteUI(card);

    var playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise
        .then(function () {
          syncPlayUI(card, true);
        })
        .catch(function () {
          video.muted = true;
          delete video.dataset.userUnmuted;
          syncMuteUI(card);
          var retry = video.play();
          if (retry && typeof retry.then === 'function') {
            retry
              .then(function () {
                syncPlayUI(card, true);
              })
              .catch(function () {
                syncPlayUI(card, false);
              });
          } else {
            syncPlayUI(card, false);
          }
        });
    } else {
      syncPlayUI(card, !video.paused);
    }
  }

  function togglePlayback(card, cards) {
    var video = card.querySelector('[data-review-video]');
    if (!video) return;
    if (video.paused) {
      playCard(card, cards);
    } else {
      pauseCard(card);
    }
  }

  function initCard(card, cards) {
    if (card.dataset.reviewVideoReady === 'true') return;

    var control = card.querySelector('[data-review-control]');
    var muteBtn = card.querySelector('[data-review-mute]');
    var video = card.querySelector('[data-review-video]');
    if (!control || !muteBtn || !video) return;

    card.dataset.reviewVideoReady = 'true';
    video.muted = true;
    delete video.dataset.userUnmuted;
    syncPlayUI(card, false);
    syncMuteUI(card);

    card.addEventListener('click', function (event) {
      if (event.target.closest('[data-review-mute]')) return;
      togglePlayback(card, cards);
    });

    control.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      togglePlayback(card, cards);
    });

    muteBtn.addEventListener('click', function (event) {
      event.stopPropagation();
      video.muted = !video.muted;
      video.dataset.userUnmuted = video.muted ? 'false' : 'true';
      syncMuteUI(card);
    });

    video.addEventListener('ended', function () {
      syncPlayUI(card, false);
    });

    video.addEventListener('pause', function () {
      if (!video.ended) syncPlayUI(card, false);
    });

    video.addEventListener('play', function () {
      syncPlayUI(card, true);
    });

    video.addEventListener('volumechange', function () {
      syncMuteUI(card);
    });
  }

  function initVideos(scope) {
    var root = scope || document;
    var containers = root.querySelectorAll('[data-home-reviews]');
    if (!containers.length && root.matches && root.matches('[data-home-reviews]')) {
      containers = [root];
    }
    Array.prototype.forEach.call(containers, function (container) {
      var cards = Array.prototype.slice.call(container.querySelectorAll('[data-video-card]'));
      if (!cards.length) return;
      cards.forEach(function (card) {
        initCard(card, cards);
      });
    });
  }

  function pauseVideosInRoot(root) {
    if (!root) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-video-card]'), function (card) {
      pauseCard(card);
    });
  }

  function initCarousel(root) {
    if (!root || root.dataset.reviewsCarouselReady === 'true') return;
    if (typeof EmblaCarousel === 'undefined') return false;

    var viewport = root.querySelector('.carousel-content-wrapper');
    if (!viewport) return false;

    var prevBtn = root.querySelector('.home-reviews-nav-prev');
    var nextBtn = root.querySelector('.home-reviews-nav-next');

    var embla = EmblaCarousel(viewport, {
      align: 'start',
      loop: false,
      slidesToScroll: 1,
      containScroll: 'trimSnaps',
      duration: 20,
    });

    root.dataset.reviewsCarouselReady = 'true';
    root._reviewsEmbla = embla;

    var sync = function () {
      var canPrev = embla.canScrollPrev();
      var canNext = embla.canScrollNext();
      if (prevBtn) prevBtn.disabled = !canPrev;
      if (nextBtn) nextBtn.disabled = !canNext;
    };

    embla.on('reInit', sync);
    embla.on('select', function () {
      sync();
      pauseVideosInRoot(root);
    });
    sync();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        embla.scrollPrev();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        embla.scrollNext();
      });
    }

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        embla.scrollPrev();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        embla.scrollNext();
      }
    });

    return true;
  }

  function initCarousels(scope) {
    var root = scope || document;
    var carousels = root.querySelectorAll('[data-home-reviews-carousel]');
    if (!carousels.length) return;

    var pending = [];
    Array.prototype.forEach.call(carousels, function (carousel) {
      if (!initCarousel(carousel)) pending.push(carousel);
    });

    // Embla may still be loading (defer) — retry briefly
    if (!pending.length || typeof EmblaCarousel !== 'undefined') return;

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      pending = pending.filter(function (carousel) {
        return !initCarousel(carousel);
      });
      if (!pending.length || tries > 40) clearInterval(timer);
    }, 50);
  }

  function init(scope) {
    initVideos(scope);
    initCarousels(scope);
  }

  function onReady() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  // Theme editor: re-init when the section is reloaded / selected
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section || !section.querySelector('[data-home-reviews]')) return;
    init(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target;
    if (!section) return;
    Array.prototype.forEach.call(section.querySelectorAll('[data-home-reviews-carousel]'), function (carousel) {
      if (carousel._reviewsEmbla) {
        carousel._reviewsEmbla.destroy();
        carousel._reviewsEmbla = null;
        delete carousel.dataset.reviewsCarouselReady;
      }
    });
  });
})();
